import React, { useEffect, useState } from "react";
import { SelectUi } from "../../../ui/SelectUi";
import { get_empleados } from "../../../../actions";

export const EmpleadosSelect = ({ ...props }) => {
  const [empleados, setEmpleados] = useState([]);
  const OnLoadEmpleados = async () => {
    const datos = await get_empleados();
    setEmpleados(datos);
  };
  useEffect(() => {
    OnLoadEmpleados();
  }, []);
  return <SelectUi data={empleados} {...props} />;
};
